import { useState, useEffect, useRef } from 'react'
import { Item, OptContent, OptWrapper, OpenButton } from './styles'

const ItemOption = ({ children, selected, handleClick, bg, borderColor, color }:any) => {
  const [enableShowMore, setEnableShowMore] = useState<boolean|any>(null)
  const [$isOpen, setIsOpen] = useState<boolean>(false)
  const opt:any = useRef()

  useEffect(() => {
    const el:any = opt.current
    if (el) {
      const divHeight = el.offsetHeight
      const lineHeight = el.style.lineHeight.replace('px', '')
      const lines = divHeight / lineHeight
      setEnableShowMore(lines > 1)
    }
  }, [opt])

  return (
    <OptWrapper>
      <Item
        selected={selected}
        onClick={handleClick}
        bg={bg}
        borderColor={borderColor}
        color={color}
      >
        <OptContent>{children}</OptContent>
      </Item>
      {enableShowMore &&
        <OpenButton
          onClick={() => setIsOpen((prev:boolean) => !prev)}
          selected={selected}
          bg={bg}
          color={color}
        >
          {!$isOpen ? <div className='right'/> : <div className='bottom'/>}
        </OpenButton>
      }
    </OptWrapper>
  )
}

export default ItemOption
